/**
 * The Canvas class provides utility methods for creating an
 * HTML canvas.
 */
export class Canvas {
  /**
   * Creates a new HTML <canvas> element with the specified width and height,
   * hides it from view, and appends it to the document body.
   * @param {number} width The width of the canvas in pixels.
   * @param {number} height The height of the canvas in pixels.
   * @returns
   */
  static create(width, height) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    canvas.style.display = 'none';
    document.body.appendChild(canvas);
    return canvas;
  }

  /**
   * Removes a previously appended <canvas> element from the document.
   * @param {*} canvas
   */
  static destroy(canvas){
    document.body.removeChild(canvas);
  }

  /**
   * Returns the 2D rendering context of the provided canvas.
   */
  static get2DContext(canvas) {
    return canvas.getContext('2d');
  }

  /**
   * Returns the WebGL rendering context of the provided canvas.
   */
  static getWebGLContext(canvas) {
    return canvas.getContext('webgl');
  }

  /**
   * Returns the WebGPU rendering context of the provided canvas.
   * This feature is experimental and may not be supported in all browsers.
   */
  static getWebGPUContext(canvas) {
    return canvas.getContext('webgpu');
  }

  /**
   * Converts the canvas content into a Blob object representing an image.
   * @param {*} canvas The canvas element whose content is to be converted.
   * @param {*} imageFormat The image format (e.g.,'image/jpeg'). Defaults to 'image/png'.
   * @param {*} quality The image quality, a number between 0 and 1. Defaults to 1.
   * @returns
   */
  static toBlob(canvas, imageFormat = 'image/png', quality = 1) {
    return new Promise(resolve => {
      canvas.toBlob(
        blob => {
          resolve(blob);
        },
        imageFormat,
        quality,
      );
    });
  }
}
